"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _router = _interopRequireDefault(require("next/router"));
var _head = _interopRequireDefault(require("next/head"));
var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));
var _styles = require("@material-ui/styles");
var _notistack = require("notistack");
var _nextSeo = require("next-seo");
var _dayjs = _interopRequireDefault(require("@date-io/dayjs"));
var _pickers = require("@material-ui/pickers");
var _analytics = require("../../lib/google/analytics");
var _apollo = require("../../lib/graphql/apollo");
var _client = require("@apollo/client");
var _elevatorTheme = _interopRequireDefault(require("../../theme/elevatorTheme"));
var _useAuth = require("../../hooks/useAuth");
var _defaultSeo = _interopRequireDefault(require("./defaultSeo"));
var _styles2 = require("@material-ui/core/styles");
var _config = require("../../theme/config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Bundles functionality of:
 * - `DefaultSeo`
 * - `ThemeProvider`
 * - `StylesProvider`
 * - `SnackbarProvider`
 * - `MuiPickersUtilsProvider`
 * - `ApolloProvider`
 * - `CSSBaseline`
 * - `AuthProvider`
 *
 * @documentation https://github.com/ELEVATORmedia/duffel-bag/wiki/ElevatorProvider
 */
var ElevatorProvider = _ref => {
  var {
    children,
    apiHost,
    reportError,
    initialApolloState = {},
    googleAnalyticsTrackingCode,
    defaultSeoProps = _defaultSeo.default,
    theme = _elevatorTheme.default,
    userQuery
  } = _ref;
  var apolloClient = (0, _apollo.useApollo)(apiHost + '/api', initialApolloState);
  (0, _react.useEffect)(() => {
    // Remove the server-side injected CSS.
    var jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentNode.removeChild(jssStyles);
    }

    //Initialize GA4 if not already intialized and set that it is.
    if (!window.GA_ANALYTICS && /*!apiHost.includes('localhost:') &&*/
    googleAnalyticsTrackingCode) {
      (0, _analytics.initGA)(googleAnalyticsTrackingCode);
      window.GA_ANALYTICS = true;

      //Log a pageview if google analytics is set and not local
      if (!apiHost.includes('localhost:')) {
        (0, _analytics.logPageView)(window.location.pathname, document.title);
        _router.default.events.on('routeChangeComplete', _analytics.logPageView);
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_head.default, null, /*#__PURE__*/_react.default.createElement("meta", {
    name: "viewport",
    content: "minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    httpEquiv: "X-UA-Compatible",
    content: "IE=edge"
  })), /*#__PURE__*/_react.default.createElement(_nextSeo.DefaultSeo, defaultSeoProps), /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_styles2.StylesProvider, {
    generateClassName: _config.generateClassName
  }, /*#__PURE__*/_react.default.createElement(_notistack.SnackbarProvider, {
    maxSnack: 3,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  }, /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _dayjs.default
  }, /*#__PURE__*/_react.default.createElement(_client.ApolloProvider, {
    client: apolloClient
  }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), /*#__PURE__*/_react.default.createElement(_useAuth.AuthProvider, {
    reportError: reportError,
    authEndpoint: apiHost + '/auth',
    userQuery: userQuery
  }, children)))))));
};
var _default = exports.default = ElevatorProvider;